import React from 'react';
import theme from '../../theme';
import { IconProps } from './props'

const EyeCloseIcon: React.FC<IconProps> = ({ id, iconColor = theme.textDark, ...rest }) => (
    <svg
        id={id}
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        <path
            d="M3.95312 5.3374C5.95313 9.67074 11.9531 9.67074 13.9531 5.3374M12.1638 7.5494L13.9531 10.0041M8.95313 8.5874V11.0041M5.74246 7.5494L3.95312 10.0041"
            stroke={iconColor}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export { EyeCloseIcon };